export class DateFormat {
  static readonly DATE: string = 'dd.MM.yyyy';
  static readonly TIME: string = 'mediumTime';
  static readonly DATE_TIME: string = 'dd.MM.yyyy HH:mm:ss';
  static readonly FROM_NOW: string = 'FROM_NOW';
}
